export default (s) => (s ? s.replace(/___/g, '_')
  .replace(/_D_/g, '$')
  .replace(/_H_/g, '#')
  .replace(/_O_/g, '[')
  .replace(/_C_/g, ']')
  .replace(/_S_/g, '/') : '');
